module.exports = __webpack_public_path__ + "assets/img/zhuangshuo--blue.4b3cf9ab.png";